import { render, staticRenderFns } from "./GradientHue.vue?vue&type=template&id=08796456&scoped=true"
import script from "./GradientHue.vue?vue&type=script&lang=js"
export * from "./GradientHue.vue?vue&type=script&lang=js"
import style0 from "./GradientHue.vue?vue&type=style&index=0&id=08796456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08796456",
  null
  
)

export default component.exports